// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"838":"857b1789","1893":"8ca6a74d","2857":"12e46b9c","3182":"857b1789"}[chunkId] + ".chunk.css";
};